// extracted by mini-css-extract-plugin
export default {"changeLink":"JQ-z","disabled":"KQ-z","inline":"LQ-z"};